(function () {
  'use strict';

  // Mobile menu
  var toggle = document.querySelector('[data-nav-toggle]');
  var header = document.querySelector('[data-header]');
  if (toggle && header) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Header turns solid black after scrolling
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Collection sort
  var sort = document.querySelector('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Product: variant price swap
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    var price = document.querySelector('[data-price]');
    var compare = document.querySelector('[data-compare]');
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (price) price.textContent = opt.dataset.price || '';
      if (compare) {
        compare.textContent = opt.dataset.compare || '';
        compare.hidden = !opt.dataset.compare;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url.toString());
    });
  }

  // Product: thumbnails
  var thumbs = document.querySelectorAll('[data-thumb]');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var img = document.getElementById('ProductMainImage');
      if (!img) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = btn.getAttribute('data-src');
    });
  });
})();

// Hero video: only load/play when it makes sense
(function () {
  'use strict';
  var sections = document.querySelectorAll('[data-hero-video]');
  if (!sections.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  sections.forEach(function (section) {
    var video = section.querySelector('video');
    if (!video || reduce || saveData) return;
    if (small && video.getAttribute('data-mobile') !== 'true') return;

    var playBtn = section.querySelector('[data-hero-play]');
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('playsinline', '');
    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
      if (playBtn) playBtn.classList.remove('is-visible');
    });
    video.src = video.getAttribute('data-src');
    var p = video.play();
    if (p && p.catch) p.catch(function () {
      // Autoplay blocked (e.g. iPhone Low Power Mode): offer a tap-to-play button
      if (playBtn) {
        playBtn.classList.add('is-visible');
        playBtn.addEventListener('click', function () { video.play(); });
        // Low Power Mode allows playback after any tap, so start on the visitor's first touch
        var kick = function () {
          video.play();
          document.removeEventListener('touchend', kick);
          document.removeEventListener('click', kick);
        };
        document.addEventListener('touchend', kick, { passive: true });
        document.addEventListener('click', kick);
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { video.pause(); }
      else { var q = video.play(); if (q && q.catch) q.catch(function () {}); }
    });
  });
})();

// Gift box quiz
(function () {
  'use strict';
  var root = document.querySelector('[data-quiz]');
  if (!root) return;

  var order = ['type', 'where', 'exp', 'budget'];
  var steps = order.map(function (k) { return root.querySelector('[data-step="' + k + '"]'); });
  var bar = root.querySelector('[data-quiz-bar]');
  var count = root.querySelector('[data-quiz-count]');
  var back = root.querySelector('[data-quiz-back]');
  var nav = root.querySelector('.quiz__nav');
  var result = root.querySelector('[data-quiz-result]');
  var topEl = root.querySelector('[data-quiz-top]');
  var whyEl = root.querySelector('[data-quiz-why]');
  var moreWrap = root.querySelector('[data-quiz-more-wrap]');
  var moreEl = root.querySelector('[data-quiz-more]');
  var bundles = [].slice.call(root.querySelectorAll('.quiz__bundle'));
  var answers = {};
  var labels = {};
  var i = 0;

  function show(n) {
    i = n;
    steps.forEach(function (s, idx) { s.hidden = idx !== n; });
    result.hidden = true;
    nav.hidden = false;
    back.hidden = n === 0;
    bar.style.width = ((n) / order.length * 100) + '%';
    count.textContent = 'Question ' + (n + 1) + ' of ' + order.length;
    var q = steps[n].querySelector('.quiz__q');
    if (q) { q.setAttribute('tabindex', '-1'); if (n > 0) q.focus({ preventScroll: true }); }
  }

  function score(b) {
    var t = b.dataset.type, w = b.dataset.where, e = b.dataset.exp;
    var s = 0;
    s += (t === 'any' || answers.type === 'unsure') ? 1 : (t === answers.type ? 4 : -3);
    s += (w === 'any' || answers.where === 'unsure') ? 1 : (w === answers.where ? 3 : -2);
    s += (e === 'any') ? 1 : (e === answers.exp ? 2 : -1);
    var price = parseInt(b.dataset.price, 10) / 100;
    if (price > 0) {
      var band = { under_100: [0, 100], '100_200': [100, 200], '200_plus': [200, 1e9] }[answers.budget];
      if (!band) { s += 1; }
      else if (price >= band[0] && price <= band[1]) { s += 2; }
      else if (price > band[1]) { s -= 3; }
      else { s -= 1; }
    }
    if (b.dataset.default === 'true') s += (answers.type === 'unsure') ? 2 : 0.5;
    return s;
  }

  function finish() {
    steps.forEach(function (s) { s.hidden = true; });
    nav.hidden = true;
    bar.style.width = '100%';
    count.textContent = 'Done';
    var ranked = bundles.map(function (b) { return { el: b, s: score(b), o: +b.dataset.order }; })
      .sort(function (a, b) { return b.s - a.s || a.o - b.o; });
    if (!ranked.length) { topEl.innerHTML = '<p>No gift boxes set up yet.</p>'; }
    else {
      topEl.innerHTML = ranked[0].el.innerHTML;
      moreEl.innerHTML = '';
      ranked.slice(1, 3).forEach(function (r) {
        var d = document.createElement('div');
        d.className = 'bundle-small';
        d.innerHTML = r.el.innerHTML;
        moreEl.appendChild(d);
      });
      moreWrap.hidden = ranked.length < 2;
    }
    whyEl.textContent = 'Matched to: ' + order.map(function (k) { return labels[k]; }).join(' · ');
    result.hidden = false;
    var h = result.querySelector('.eyebrow');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  root.addEventListener('click', function (ev) {
    var opt = ev.target.closest('.quiz__opt');
    if (opt) {
      var key = order[i];
      answers[key] = opt.getAttribute('data-value');
      var strong = opt.querySelector('strong');
      labels[key] = strong ? strong.textContent : answers[key];
      if (i < order.length - 1) show(i + 1); else finish();
      return;
    }
    if (ev.target.closest('[data-quiz-back]') && i > 0) { show(i - 1); return; }
    if (ev.target.closest('[data-quiz-restart]')) { answers = {}; labels = {}; show(0); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  show(0);
})();

// Character counter for engraving text
(function () {
  document.querySelectorAll('[data-count-input]').forEach(function (input) {
    var out = document.querySelector('[data-count-for="' + input.id + '"]');
    if (!out) return;
    var max = input.getAttribute('maxlength');
    var update = function () { out.textContent = input.value.length + ' / ' + max; };
    input.addEventListener('input', update);
    update();
  });
})();
